/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Ready_For_PickupInputs */

const en_inbound_field_ready_for_pickup = /** @type {(inputs: Inbound_Field_Ready_For_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready for pickup`)
};

/**
* | output |
* | --- |
* | "Ready for pickup" |
*
* @param {Inbound_Field_Ready_For_PickupInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_ready_for_pickup = /** @type {((inputs?: Inbound_Field_Ready_For_PickupInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Ready_For_PickupInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_ready_for_pickup(inputs)
});